/*
 * PHARMACISTA - Saudi National Day 2026 gift hamper (added 2026-09-23)
 * Adds the free gift hamper to the cart when the threshold is reached:
 *   cart >= 199 SAR  -> Small hamper (free via automatic discount)
 *   cart >= 499 SAR  -> Big hamper   (free via code NATIONALDAY-GIFT, applied here)
 * Removes / swaps the hamper when the cart changes. Inactive outside 23 Sep - 10 Oct 2026.
 * Safe to delete this file and its script tag in layout/theme.liquid after the campaign.
 */
(function () {
  "use strict";
  if (window.__sndGiftHamperLoaded) return;
  window.__sndGiftHamperLoaded = true;

  var START = Date.parse("2026-09-23T00:00:00+03:00");
  var END = Date.parse("2026-10-11T00:00:00+03:00");
  var now = Date.now();
  if (now < START || now >= END) return;

  var SMALL = 49797592547555;
  var BIG = 49797592580323;
  var SMALL_MIN = 19900; // halalas
  var BIG_MIN = 49900;
  var CODE = "NATIONALDAY-GIFT";
  var OWN = "X-SND-Gift";

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  root = root.replace(/\/?$/, "/");
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var again = false;
  var timer = null;
  var rounds = 0; // safety: max cart corrections per page view

  function api(path, body) {
    var opts = { method: body ? "POST" : "GET", credentials: "same-origin", headers: { Accept: "application/json" } };
    opts.headers[OWN] = "1";
    if (body) {
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(root + path, opts).then(function (r) { return r.json(); });
  }

  function isGift(id) { return id === SMALL || id === BIG; }
    var noOfferCache = {};
  function markNoOffers(cart) {
    var handles = [];
    cart.items.forEach(function (it) {
      if (!isGift(it.variant_id) && !(it.handle in noOfferCache) && handles.indexOf(it.handle) === -1) handles.push(it.handle);
    });
    return Promise.all(handles.map(function (h) {
      return nativeFetch(root + "products/" + encodeURIComponent(h) + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (p) { noOfferCache[h] = (p.tags || []).some(function (t) { return String(t).toLowerCase() === "no-offers"; }); })
        .catch(function () { noOfferCache[h] = false; });
    })).then(function () {
      cart.items.forEach(function (it) { it._noOffer = !!noOfferCache[it.handle]; });
      return cart;
    });
  }

  function refreshUI() {
    if (/\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  function reconcile() {
    if (busy) { again = true; return; }
    if (rounds >= 6) return;
    busy = true;
    api("cart.js").then(markNoOffers).then(function (cart) {
      var base = 0;
      var lines = {};
      lines[SMALL] = [];
      lines[BIG] = [];
      cart.items.forEach(function (it) {
        if (isGift(it.variant_id)) lines[it.variant_id].push(it);
        else base += it._noOffer ? 0 : it.final_line_price;
      });

      var want = base >= BIG_MIN ? BIG : (base >= SMALL_MIN ? SMALL : null);
      var ops = [];

      [SMALL, BIG].forEach(function (v) {
        lines[v].forEach(function (it, i) {
          var q = (v === want && i === 0) ? 1 : 0;
          if (it.quantity !== q) ops.push(function () { return api("cart/change.js", { id: it.key, quantity: q }); });
        });
        if (v === want && !lines[v].length) {
          ops.push(function () { return api("cart/add.js", { items: [{ id: v, quantity: 1 }] }); });
        }
      });

      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var hasCode = codes.some(function (c) { return String(c).toUpperCase() === CODE; });
      if (want === BIG && !hasCode) {
        ops.push(function () { return api("cart/update.js", { discount: codes.concat([CODE]).join(",") }); });
      } else if (want !== BIG && hasCode) {
        var rest = codes.filter(function (c) { return String(c).toUpperCase() !== CODE; });
        ops.push(function () { return api("cart/update.js", { discount: rest.join(",") }); });
      }

      if (!ops.length) return false;
      rounds++;
      return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve()).then(function () { return true; });
    }).then(function (changed) {
      busy = false;
      if (changed) refreshUI();
      if (again) { again = false; schedule(); }
    }).catch(function () {
      busy = false;
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 350);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ""));
  }

  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url);
    var own = init && init.headers && (init.headers[OWN] || (init.headers.get && init.headers.get(OWN)));
    var p = nativeFetch(input, init);
    if (!own && isCartMutation(url)) p.then(schedule, schedule);
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) this.addEventListener("loadend", schedule);
    return xhrOpen.apply(this, arguments);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", reconcile);
  else reconcile();
})();
